import * as React from "react"
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function ExclamationMarkIcon(props: SvgIconProps): JSX.Element {
    const defaultColor = "primary";
    const color = props.color || defaultColor;
    return (
        <SvgIcon
            {...props}
            color={color}
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2284_5990)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.952 18.999A9.25 9.25 0 1018.049 5 9.25 9.25 0 005.952 19zm6.83 3.723a10.75 10.75 0 11-1.563-21.443 10.75 10.75 0 011.562 21.443zM12 5.25a.75.75 0 01.75.75v8a.75.75 0 01-1.5 0V6a.75.75 0 01.75-.75zm0 11a1 1 0 011 1v.042a1 1 0 01-2 0v-.042a1 1 0 011-1z"
                />
            </g>
            <defs>
                <clipPath id="clip0_2284_5990">
                    <path fill="#fff" d="M0 0H24V24H0z" />
                </clipPath>
            </defs>
        </SvgIcon>
    )
}